<template>
  <BaseModule
    @click="click"
    :index="index"
    :data="data"
    :isEditMode="isEditMode"
  >
    <div class="text-module-body"><slot></slot></div>
  </BaseModule>
</template>

<script>
import BaseModule from './BaseModule.vue'
export default {
  components: {
    BaseModule
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click () { this.$emit('click') }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.text-module-body {
  line-height: 1.1rem;
  color: var(--color5);
  @media (--mediaPc) {
    padding: 24px 53px;
    font-size: var(--textSize3);
  }
  @media (--mediaMobile) {
    padding: 0 25px calc(32px / var(--scaleMobile)) 40px;
    font-size: var(--textSize3Mobile);
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/TextModule.vue